
import Box from '@mui/material/Box';
import { IRapportBoxControl } from './RapportMallTypes';
import { SELECTED_SHADOW, getPositionStyle } from './RapportMallUtils';
import { RapportKontrollEditPosition } from './RapportKontrollEditPosition';

export interface IProps {
  ctrl: IRapportBoxControl;
  sx?: any;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onSelect?: (path: number[]) => void;
  onUpdate?: (updatedControl: IRapportBoxControl) => void;
  controlPath: number[];
  selected?: boolean;
  maxWidth: number;
  defaultHeight: number;
}

export const RapportBox: React.FC<IProps> = props => {
  const {
    ctrl,
    sx,
    onMouseEnter,
    onMouseLeave,
    selected,
    maxWidth,
    defaultHeight,
  } = props;
  const handleSelect = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    if (props.onSelect) {
      props.onSelect(props.controlPath);
    }
  };
  return (
    <Box
      sx={{
        boxShadow: selected ? SELECTED_SHADOW : undefined,
        border: '1px solid #aaa',
        boxSizing: 'border-box',
        padding: 0,
        ...getPositionStyle(
          ctrl,
          props.controlPath.length > 1,
          maxWidth,
          defaultHeight
        ),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        ...sx,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={handleSelect}
      data-control-path={props.controlPath.join('-')}
    />
  );
};

export interface IRapportBoxEditProps {
  value: IRapportBoxControl;
  onChange: (ctrl: IRapportBoxControl) => void;
}

export const RapportBoxEdit: React.FC<IRapportBoxEditProps> = props => (
  <Box sx={{ mt: 2 }}>
    <RapportKontrollEditPosition
      caption="Ruta"
      value={props.value}
      onChange={props.onChange}
    />
  </Box>
);
